// Copyright (c) 2016 Deere & Company

import DbsSettings from './components/dbs-settings';
import actionCreators from '../shared/action-creators';
import {connect} from 'react-redux';
import {handleOnPageLeave} from '../shared/services/handle-on-page-leave';

const getStateToBindToContainerProps = state => ({
    ...state.user.preferences,
    userDBSSettings: state.user.details.settings.dbs
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps,
        handleOnPageLeave
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(DbsSettings);



// WEBPACK FOOTER //
// ./src/user/dbs-settings/state-connector.js